export default __webpack_public_path__ + "static/media/image_ico.642994fe.svg";